import React from 'react';

import {BulkActionResult} from 'src/components/bulk-tool';

import {AssignAccountEntitlementsResultModal} from './assign-account-entitlements.result.modal';
import {
    clearResult,
    selectAssignAccountEntitlementsBulkUuid,
    selectAssignAccountEntitlementsShown,
    selectAssignAccountEntitlementsTask,
} from './assign-account-entitlements.slice';


export const AssignAccountEntitlementsResult = () => (
    <BulkActionResult
        actionIdSelector={selectAssignAccountEntitlementsBulkUuid}
        actionTaskSelector={selectAssignAccountEntitlementsTask}
        actionShownSelector={selectAssignAccountEntitlementsShown}
        clearResult={clearResult}>
        {({id, onClose}) => (
            <AssignAccountEntitlementsResultModal id={id} onClose={onClose}/>
        )}
    </BulkActionResult>
);
